module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_pre_screening-20765286031718b4483e5521a6ee35d7.svg";